import React from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Box, Typography, Divider } from '@mui/material';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';

const SearchBar = props => {
  const { languageData, onBack } = props;
  return (
    <FlexContainer className={'margt60 align-items-end'}>
      <i class="fa fa-chevron-left" onClick={onBack}></i>
    </FlexContainer>
  );
};

const StillBuildingView = props => {
  const { initialValues, onSubmit, loading, onBack, onRegister, languageData } =
    props;
  console.log(props);
  return (
    <FlexContainer className="flex-column height-700px padlr10 justify-start items-center  bgGradientSignUpPurple0 fontWhite">
      <SearchBar languageData={languageData} onBack={onBack} />
      <FlexContainer className={'flex-column padlr30 margb30'}>
        <Label
          className={`margtb40 ${
            languageData === 'EN' ? 'text-20' : 'text-16'
          }`}
        >
          🔧{' '}
          <strong>
            {languageData === 'EN'
              ? "We're still building this part!"
              : '¡Aún estamos construyendo esta parte!'}
          </strong>
        </Label>

        <Label className="text-16 margb16" style={{ lineHeight: '2.5' }}>
          {languageData === 'EN'
            ? "Thanks for stopping by, this section isn't quite ready yet."
            : 'Gracias por visitarnos, esta sección aún no está lista.'}
        </Label>

        <Label className="text-16 margb16" style={{ lineHeight: '2.5' }}>
          {languageData === 'EN'
            ? 'But don’t worry, you can still search and book your favorite coworking spaces while we finish things up.'
            : 'Pero no te preocupes, aún puedes buscar y reservar tus espacios de coworking favoritos mientras terminamos.'}
        </Label>

        <Label className="text-16 margt20 ">
          🚀{' '}
          {languageData === 'EN'
            ? 'Come back soon for more!'
            : '¡Vuelve pronto para más novedades!'}
        </Label>
      </FlexContainer>
    </FlexContainer>
  );
};

export default StillBuildingView;
